export default function Contact() {
  return (
    <section id="contact" className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-gray-900 mb-4">Get in Touch</h2>
          <div className="w-16 sm:w-24 h-px bg-gray-300 mx-auto"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-12">
            <div className="bg-white p-8 sm:p-12 shadow-sm text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-3xl text-gray-900"></i>
              </div>
              <h3 className="font-serif text-xl sm:text-2xl text-gray-900 mb-3">Email Us</h3>
              <a
                href="mailto:williamandmary2026@gmail.com"
                className="text-gray-600 text-sm font-light tracking-wide hover:text-gray-900 transition-colors cursor-pointer break-all px-4"
              >
                williamandmary2026@gmail.com
              </a>
            </div>

            <div className="bg-white p-8 sm:p-12 shadow-sm text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-3xl text-gray-900"></i>
              </div>
              <h3 className="font-serif text-xl sm:text-2xl text-gray-900 mb-3">Call Us</h3>
              <a
                href="tel:+12149146129"
                className="text-gray-600 text-sm font-light tracking-wide hover:text-gray-900 transition-colors cursor-pointer"
              >
                (214) 914-6129
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
